var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGauge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 3.75a5.36 5.36 0 0 0-2.924.865A5.14 5.14 0 0 0 3.147 6.91a5 5 0 0 0-.297 2.942 5.07 5.07 0 0 0 1.431 2.612.75.75 0 1 1-1.048 1.074A6.57 6.57 0 0 1 1.38 10.15a6.5 6.5 0 0 1 .386-3.827 6.64 6.64 0 0 1 2.49-2.964A6.85 6.85 0 0 1 8 2.25c1.331 0 2.634.385 3.743 1.11a6.64 6.64 0 0 1 2.49 2.963 6.5 6.5 0 0 1 .387 3.827 6.57 6.57 0 0 1-1.853 3.387.75.75 0 1 1-1.048-1.074 5.07 5.07 0 0 0 1.43-2.612 5 5 0 0 0-.296-2.942 5.14 5.14 0 0 0-1.93-2.294A5.35 5.35 0 0 0 8 3.75"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 9a1.25 1.25 0 1 1-1.073-1.238L9.97 5.97a.75.75 0 1 1 1.06 1.06L9.238 8.823q.012.087.012.177"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGauge);
export default ForwardRef;